'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsWrapperStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),

  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  colorScheme: 'dark'
};

var style = function style(_ref) {
  var themeFromProvider = _ref.theme,
      colorScheme = _ref.colorScheme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var backgroundColor = theme.reactackle.components.tabs.tabs.style[colorScheme].backgroundColor,
      fontColor = theme.reactackle.components.tabs.tab.style[colorScheme].fontColor;
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  return '\n    background-color: ' + backgroundColor + ';\n    color: ' + fontColor + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
};

var TabsWrapperStyled = exports.TabsWrapperStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TabsWrapperStyled'
})(['display:flex;align-items:stretch;position:relative;', ';'], style);

TabsWrapperStyled.propTypes = propTypes;
TabsWrapperStyled.defaultProps = defaultProps;
TabsWrapperStyled.displayName = 'TabsWrapperStyled';